const FAKE_EVENT = { sender: { send: () => { } } };
export class WebIpc {
    listeners = new Map();
    handlers = new Map();
    onSend = null;
    on(channel, listener) {
        let set = this.listeners.get(channel);
        if (!set) {
            set = new Set();
            this.listeners.set(channel, set);
        }
        set.add(listener);
        return this;
    }
    once(channel, listener) {
        const wrapper = (event, ...args) => {
            this.removeListener(channel, wrapper);
            listener(event, ...args);
        };
        return this.on(channel, wrapper);
    }
    removeListener(channel, listener) {
        const set = this.listeners.get(channel);
        if (set)
            set.delete(listener);
        return this;
    }
    removeAllListeners(channel) {
        if (channel) {
            this.listeners.delete(channel);
        }
        else {
            this.listeners.clear();
        }
        return this;
    }
    send(channel, ...args) {
        if (this.onSend)
            this.onSend(channel, args);
    }
    invoke(channel, ...args) {
        const handler = this.handlers.get(channel);
        if (!handler) {
            return Promise.reject(new Error(`No handler registered for "${channel}"`));
        }
        try {
            return Promise.resolve(handler(FAKE_EVENT, ...args));
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    handle(channel, handler) {
        this.handlers.set(channel, handler);
    }
    emit(channel, ...args) {
        const set = this.listeners.get(channel);
        if (!set)
            return;
        for (const listener of Array.from(set)) {
            listener(FAKE_EVENT, ...args);
        }
    }
}
export function createSender(ipc) {
    return {
        send: (channel, ...args) => ipc.emit(channel, ...args),
    };
}
